// removed by extract-text-webpack-plugin
module.exports = {"mobile-s":"320px","ipad-portrait":"768px","ipad":"1024px","desktop":"1366px","desktop-s":"1280px","large":"1600px","extra-large":"1920px","sideNavCollapsed":"60px","secondLevel":"206px"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/foundations/Grids/MainContainer.css
// module id = 797
// module chunks = 0